import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

import YMMPicker from '../settings/components/YMMPicker';
import DealerOverrides from '../feed-overrides/components/DealerOverrides';
import DisplayFeedOverrides from '../feed-overrides/components/DisplayFeedOverrides';

const styles = {
  dealerName: {
    marginBottom: 10,
  },
  overrides: {},
};

class DisplayFeedSettings extends Component {
  constructor(props) {
    super(props);
    const { feedOverrides } = props;
    this.state = { ...feedOverrides };
  }

  handleOverrideChange = (override) => {
    this.setState((state) => ({ ...state, ...override }));
    this.props.onChange(override);
  }

  render() {
    const { makes, models, years } = this.props.stores;
    const { makeId, modelId, year } = this.props.ymmt;

    return (
      <div className={this.props.className}>
        <YMMPicker
          makes={makes}
          models={models}
          years={years}
          makeId={makeId}
          modelId={modelId}
          year={year}
          onYMMTChange={this.props.onChange}
        />
        <DealerOverrides
          className={this.props.classes.dealerName}
          name={this.state.dealerName}
          logoUrl={this.state.dealerLogoUrl}
          onChange={this.handleOverrideChange}
        />
        <DisplayFeedOverrides
          className={this.props.classes.overrides}
          defaultValues={this.props.feedRow}
          values={this.state}
          onChange={this.handleOverrideChange}
        />
      </div>
    );
  }
}

DisplayFeedSettings.propTypes = {
  ymmt: PropTypes.shape({
    makeId: PropTypes.string,
    modelId: PropTypes.string,
    year: PropTypes.string,
  }),
  stores: PropTypes.shape({
    makes: PropTypes.object,
    models: PropTypes.array,
    years: PropTypes.arrayOf(PropTypes.string),
  }),
  feedOverrides: PropTypes.object,
  feedRow: PropTypes.object,
  onChange: PropTypes.func,
  className: PropTypes.string,
  classes: PropTypes.object,
};

DisplayFeedSettings.defaultProps = {
  onChange: (values) => console.warn('No onChange hander for DisplayFeedSettings', values),
};

export default withStyles(styles)(DisplayFeedSettings);



// WEBPACK FOOTER //
// ./src/settings/DisplayFeedSetttings.jsx